import { PersonIcon, CheveronRightIcon } from '@wkda/icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function AccountMenu({
  isLoggedIn,
  accountItem,
  logoutItem,
  LinkComponent
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [accountItem && isLoggedIn ? logoutItem ? /*#__PURE__*/_jsx("div", {
      className: "wa-nav-vertical__item",
      children: /*#__PURE__*/_jsx(LinkComponent, {
        className: "wa-nav-vertical__item-link",
        href: logoutItem?.link,
        children: logoutItem?.title
      })
    }) : null : null, accountItem ? /*#__PURE__*/_jsx("div", {
      className: "wa-nav-vertical__item wa-account-item",
      children: /*#__PURE__*/_jsxs(LinkComponent, {
        className: "wa-nav-vertical__item-link wa-account-link",
        href: accountItem?.link,
        children: [/*#__PURE__*/_jsx(PersonIcon, {}), accountItem?.title, /*#__PURE__*/_jsx(CheveronRightIcon, {})]
      })
    }) : null]
  });
}